import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { UserActivityDetailSkeleton } from '@components/Feed/User/Skeleton';
import { DeprecatedDynamicSkeleton } from '@components/main-components/skeleton/Skeleton';
import { CARD_CONTAINER_CSS, ComponentContainer } from '../shared';

export const ArtistDropSkeleton = () => {
  return (
    <ComponentContainer noPadding>
      <UserActivityDetailSkeleton />
      <Container>
        <DeprecatedDynamicSkeleton width="100%" height={343} borderRadius={8} />
      </Container>
    </ComponentContainer>
  );
};

const Container = styled('div', {
  ...CARD_CONTAINER_CSS,
});
